import { type FC, useMemo } from 'react';
import * as Styled from './styled';
import { type Props } from './types';

export const DEFAULT_FILTER_MAIN_DETAIL_LAYOUT_PARAMS: Props['params'] = {
  filterWidth: '326px',
  mainWidth: 'auto',
  detailWidth: 'minmax(370px, 25%)',
};

export const FilterMainDetailLayout: FC<Props> = ({
  filter,
  main = <div />,
  detail,
  params = DEFAULT_FILTER_MAIN_DETAIL_LAYOUT_PARAMS,
}) => {
  const {
    filterWidth = DEFAULT_FILTER_MAIN_DETAIL_LAYOUT_PARAMS.filterWidth,
    mainWidth = DEFAULT_FILTER_MAIN_DETAIL_LAYOUT_PARAMS.mainWidth,
    detailWidth = DEFAULT_FILTER_MAIN_DETAIL_LAYOUT_PARAMS.detailWidth,
  } = params;

  const isFilter = Boolean(filter);
  const isDetail = Boolean(detail);

  const templateConfig = useMemo(
    () => `${filterWidth} ${mainWidth} ${detailWidth}`,
    [detailWidth, filterWidth, mainWidth]
  );

  return (
    <Styled.Container templateConfig={templateConfig}>
      {isFilter && <section>{filter}</section>}
      <Styled.Main isFilter={isFilter} isDetail={isDetail}>
        {main}
      </Styled.Main>
      {isDetail && <Styled.Detail>{detail}</Styled.Detail>}
    </Styled.Container>
  );
};
